<div id="table_info" class="tablewrap resizetable tabpage hidden">
    <div class="table tableinfo">
        <table fixedcols="[0]" id="trackinfotable">
          <tr>
            <th><input type="checkbox" /></th>
            <th class="datetime_column">{{'Start'|translate }}</th>
            <th class="datetime_column">{{'Finish'|translate }}</th>
            <th class="time_column">{{'Duration'|translate }}</th>
            <th class="object_column">{{'Object'|translate }}</th>
            <th class="mileage_column">{{'Mileage'|translate }}</th>
            <th class="speed_column">{{'Max. speed'|translate }}</th>
            <th>{{'Idling'|translate }}</th>
            <th>{{'Fuel consumption'|translate }}</th>
            <th>{{'Violations'|translate }}</th>
            <th>{{'Penalty'|translate }}</th>
          </tr>
        </table>
    </div>
    <app-pagination [viewmode]="'print excel'" [printElementID]="'trackinfotable'"></app-pagination>
</div>
